import React from "react";

import Regions from "./regions";

const Tree = ({ addresses, setFieldsValue }) => {
	return (
		<div className="tree">
			{addresses.map((companyObj) => {
				return (
					<div key={companyObj.companyId} className="company-container">
						<div className="texts">
							<div>УК {companyObj.company}</div>
							<div>Районы</div>
						</div>
						<Regions companyObj={companyObj} setFieldsValue={setFieldsValue} />
					</div>
				);
			})}
		</div>
	);
};

export default Tree;
